import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PendingTests from './employee/PendingTests';
import './EmployeeDashboard.css';

const EmployeeDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="employee-dashboard">
      <div className="dashboard-header">
        <div>
          <h1>Employee Dashboard</h1>
          <p>Welcome, {user?.name}</p>
        </div>
        <button
          className="button-secondary"
          onClick={() => navigate('/chat')}
        >
          💬 Quick Chat
        </button>
      </div>

      <div className="dashboard-content">
        <PendingTests />
      </div>
    </div>
  );
};

export default EmployeeDashboard;
